<template>
  <v-card>
    <v-card-title class="headline">График экспериментальных сессий в 2026 году
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="sessionsDialog_activeTab" fixed-tabs>
        <v-tab :key="0">Синхротрон</v-tab>
        <v-tab :key="1">ИР-8</v-tab>
        <v-tab :key="2">Лабораторные приборы</v-tab>
      </v-tabs>

    </v-card-text>

    <v-card-text>
      <v-tabs-items v-model="sessionsDialog_activeTab" class="white elevation-1">
            <v-tab-item :key="0">
              <v-row>
                <v-col cols="4" style="margin: auto;">
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">1 сессия 2026</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">2 сессия 2026</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">3 сессия 2026</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">1 сессия 2027</b>
                </v-col>
                <v-col cols="6" style="margin: auto;">
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Период планирования:</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  2 февраля 2026 - <br>30 апреля 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  13 мая 2026 - <br>10 июля 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  08 сентября 2026 - <br>26 декабря 2026
                </v-col>
                <!-- <v-col cols="2" style="margin: auto;">
                  2 февраля 2026 - <br>30 апреля 2026
                </v-col> -->
                <v-col cols="2" style="margin: auto; text-align: center;">
                  Информация будет размещена позднее
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Крайний срок приема заявок:</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  19 октября 2025
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  31 марта 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  17 июня 2025
                </v-col>
                <!-- <v-col cols="2" style="margin: auto;">
                  19 октября 2025
                </v-col> -->
                <v-col cols="2" style="margin: auto;">
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Уведомление о решении по заявкам:</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  до 15 января 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  до 15 апреля 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  до 10 августа 2026
                </v-col>
                <!-- <v-col cols="2" style="margin: auto;">
                  15 декабря 2025
                </v-col> -->
                <v-col cols="2" style="margin: auto;">
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-row>
                <v-col cols="4" style="margin: auto;">
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">1 сессия 2026</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">2 сессия 2026</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  <b style="font-size: 18px;">1 сессия 2027</b>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Период планирования:</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  2 февраля 2026 - <br>26 июня 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  28 сентября 2026 - <br>25 декабря 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  1 февраля 2027 - <br>25 июня 2027
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Крайний срок приема заявок:</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  19 октября 2025
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  17 июня 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  18 октября 2026
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Уведомление о решении по заявкам:</b>
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  до 15 января 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  до 10 августа 2026
                </v-col>
                <v-col cols="2" style="margin: auto;">
                  до 11 декабря 2026
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-row>
                <v-col cols="3" style="margin: auto;">
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">1 сессия 2026</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">2 сессия 2026</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">3 сессия 2026</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">4 сессия 2026</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">5 сессия 2026</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">6 сессия 2026</b>
                </v-col>
                <!-- <v-col style="margin: auto;">
                  <b style="font-size: 18px;">7 сессия 2025</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">8 сессия 2025</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">9 сессия 2025</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">10 сессия 2025</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">11 сессия 2025</b>
                </v-col>
                <v-col style="margin: auto;">
                  <b style="font-size: 18px;">12 сессия 2025</b>
                </v-col> -->
              </v-row>
              <v-row>
                <v-col cols="3" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Период планирования:</b>
                </v-col>
                <v-col style="margin: auto;">
                  12.01.2026 - 31.01.2026
                </v-col>
                <v-col style="margin: auto;">
                  02.02.2026 - 27.02.2026
                </v-col>
                <v-col style="margin: auto;">
                  02.03.2026 - 31.03.2026
                </v-col>
                <v-col style="margin: auto;">
                  01.04.2026 - 30.04.2026
                </v-col>
                <v-col style="margin: auto;">
                  04.05.2026 - 29.05.2026
                </v-col>
                <v-col style="margin: auto;">
                  01.06.2026 - 30.06.2026
                </v-col>
                <!-- <v-col style="margin: auto;">
                  01.07.2025 - 31.07.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.08.2025 - 31.08.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.09.2025 - 30.09.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.10.2025 - 31.10.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.11.2025 - 30.11.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.12.2025 - 30.12.2025
                </v-col> -->
              </v-row>
              <v-row>
                <v-col cols="3" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Крайний срок приема заявок:</b>
                </v-col>
                <v-col style="margin: auto;">
                  01.12.2025
                </v-col>
                <v-col style="margin: auto;">
                  11.01.2026
                </v-col>
                <v-col style="margin: auto;">
                  01.02.2026
                </v-col>
                <v-col style="margin: auto;">
                  01.03.2026
                </v-col>
                <v-col style="margin: auto;">
                  01.04.2026
                </v-col>
                <v-col style="margin: auto;">
                  03.05.2026
                </v-col>
                <!-- <v-col style="margin: auto;">
                  02.06.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.07.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.08.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.09.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.10.2025
                </v-col>
                <v-col style="margin: auto;">
                  01.11.2025
                </v-col> -->

              </v-row>
              <v-row>
                <v-col cols="3" style="margin: auto; text-align: right;">
                  <b style="font-style: italic;">Уведомление о решении по заявкам:</b>
                </v-col>
                <v-col style="margin: auto;">
                  22.12.2025
                </v-col>
                <v-col style="margin: auto;">
                  22.01.2026
                </v-col>
                <v-col style="margin: auto;">
                  12.02.2026
                </v-col>
                <v-col style="margin: auto;">
                  12.03.2026
                </v-col>
                <v-col style="margin: auto;">
                  13.04.2026
                </v-col>
                <v-col style="margin: auto;">
                  19.05.2026
                </v-col>
                <!-- <v-col style="margin: auto;">
                  до 19.06.2025
                </v-col>
                <v-col style="margin: auto;">
                  до 18.07.2026
                </v-col>
                <v-col style="margin: auto;">
                  до 19.08.2026
                </v-col>
                <v-col style="margin: auto;">
                  до 18.09.2026
                </v-col>
                <v-col style="margin: auto;">
                  до 17.10.2026
                </v-col>
                <v-col style="margin: auto;">
                  до 30.11.2026
                </v-col> -->
              </v-row>
            </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-card-text>
      При подготовке заявок на эксперимент просим обращать внимание на даты окончания заявочной кампании каждой экспериментальной сессии.<br>
      <!-- Если Вы хотите попасть в первую экспериментальную сессию, которая начнётся после новогодних праздников, то рекомендуем поторопиться, так как крайний срок подачи заявки для нее - 16.12.2024 года.<br> -->
      Все заявки, поданные позже указанной даты будут отнесены на следующую сессию.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text
        @click="$emit('closeModal')">Закрыть
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'SessionList',
  data() {
    return {
      sessionsDialog_activeTab: 0,
    }
  },

  methods: {
  },

};
</script>
